import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { isOrigemLancamentoCadastroErp } from '../../../../models/origem-lancamento-cadastro';
import { CanalVenda, CanalVendaID } from '../../../common/canais-venda/domain';

interface Config {
    isOrigemERP: boolean;
    isCanalVendaDireto: boolean;
}

@Component({
    selector: 'sgt-pedido-table-badges-container',
    templateUrl: './pedido-table-badges-container.component.html',
    styleUrls: ['./pedido-table-badges-container.component.less']
})
export class PedidoTableBadgesContainerComponent implements OnInit, OnChanges {
    /** Config. do component */
    config: Config;

    /** Dados do pedido */
    @Input() pedido: {
        id: number;
        // Plataforma de Origem
        origemLancamento: number;
        logoURLPlataformaIntegracaoErp: string;
        nomeIntegracaoErp: string;
        logoURLPlataformaIntegracaoEcommerce: string;
        nomeIntegracaoEcommerce: string;
        // Canal de Venda
        canalVenda: CanalVenda;
        // Pedido Fracionado
        pedidoFracionado: boolean;
        // Pedido Filho
        pedidoFilho: boolean;
    }

    /** Se é a integração com ERP v1 */
    @Input() isIntegracaoErpV1: boolean;

    ngOnInit(): void {
        this.setConfig();
    }


    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'plataforma') {
                if (!changes[propName].isFirstChange()) {
                   this.setConfig();
                }
            }
        }
    }

    private setConfig() {
        this.config = {
            isOrigemERP: isOrigemLancamentoCadastroErp(this.pedido?.origemLancamento ?? null),
            isCanalVendaDireto: CanalVendaID.isCanalVendaDireto(this.pedido?.canalVenda?.id ?? null)
        }
    }
}
